import { I18n } from 'aws-amplify';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'i18n' })
export class I18nPipe implements PipeTransform {
  transform(text: string) {
    return I18n.get(text);
  }
}
